import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (pw !== pw2) { setErr("Passwords don't match."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password: pw });
      if (data.token) localStorage.setItem("ba30_token", data.token);
      await refresh();
      toast.success("Password set. Welcome to BA30.");
      nav("/onboarding", { replace: true });
    } catch (e) {
      const msg = formatApiError(e.response?.data?.detail) || e.message;
      setErr(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12" data-testid="set-password-page">
      <div className="w-full max-w-md">
        <div className="label-eyebrow text-primary">Activate Your Account</div>
        <h1 className="mt-4 font-display text-4xl md:text-5xl uppercase leading-[0.95]">Set your <span className="text-primary">password.</span></h1>
        <p className="mt-4 text-foreground/75 text-sm">One last step before your 12-week rebuild starts.</p>

        <form onSubmit={submit} className="mt-8 bg-card border border-border rounded-lg p-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Password</label>
            <input required type="password" minLength={6} value={pw} onChange={(e)=>setPw(e.target.value)}
              className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="set-password-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Confirm password</label>
            <input required type="password" minLength={6} value={pw2} onChange={(e)=>setPw2(e.target.value)}
              className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="set-password-confirm" />
          </div>
          {err && <div className="text-sm text-destructive" data-testid="set-password-error">{err}</div>}
          <button disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="set-password-submit">
            {busy ? "Saving…" : "Set password & enter portal"}
          </button>
        </form>
      </div>
    </div>
  );
}
